import { Turbo } from "@hotwired/turbo-rails"

export async function turboStreamRequest(url, method = 'GET') {
  const response = await fetch(url, {
    method: method,
    headers: {
      'Accept': 'text/vnd.turbo-stream.html',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
    }
  })

  if (response.ok) {
    const html = await response.text()
    Turbo.renderStreamMessage(html)
  }
}
